<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Your Lists</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item
                v-for="list in lists"
                :key="list.listID"
                :to="{ name: 'editor', params: { id: list.listID } }"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ list.listName }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="list.sharedUsers">
                  <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-btn fab color="primary" right absolute @click="newList.dialog = true">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="newList.dialog" max-width="350">
      <v-card>
        <v-card-title>New List</v-card-title>
        <v-card-text>
          <v-text-field
            label="List Name"
            v-model="newList.listName"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="newList = { listName: '', dialog: false }"
            >Cancel</v-btn
          >
          <v-btn text color="primary" @click="createList()">Create List</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Lists",
  data() {
    return {
      newList: {
        listName: "",
        dialog: false
      }
    };
  },
  components: {},
  mounted() {
    this.loadLists();
  },
  computed: {
    ...mapState(["lists", "user"])
  },
  methods: {
    ...mapMutations(["addList", "setLists"]),
    loadLists() {
      let lists = [];
      const userID = this.user.uid;
      const formattedList = doc => {
        const list = doc.data();
        list.listID = doc.id;
        return list;
      };

      this.$db
        .collection("lists")
        .where("userID", "==", userID)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const list = formattedList(doc);
            lists.push(list);
          });
        });
      this.$db
        .collection("lists")
        .where("sharedUIDs", "array-contains", userID)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const list = formattedList(doc);
            lists.push(list);
          });
        });
      this.setLists(lists);
    },
    createList() {
      const self = this;
      this.$db
        .collection("lists")
        .add({
          listName: this.newList.listName,
          dateModified: "",
          listItems: [],
          userID: this.user.uid
        })
        .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
          self.$router.push({ name: "editor", params: { id: docRef.id } });
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    }
  }
};
</script>
